import {useRouter} from 'next/router';

import {useCanonicalUrl} from '@udemy/head-seo';
import {META_DEFAULT_BASE_URL} from '@udemy/nextjs-core';
import {AIEraCareerBanner} from '@udemy/react-banners';
import {SubscriptionPlanProductType, SubscriptionPlansProvider} from '@udemy/subscription-graphql';

export const ExploreMoreSectionAIBanner = () => {
    const router = useRouter();
    const {url: canonicalUrl} = useCanonicalUrl(
        router as {locale: string; asPath: string},
        [],
        META_DEFAULT_BASE_URL,
    );
    return (
        <SubscriptionPlansProvider
            subscriptionPlanQueryVariables={[
                {
                    filters: {productType: SubscriptionPlanProductType.Consumersubscription},
                    marketingURL: `${new URL(canonicalUrl).origin}${router.asPath}`,
                },
            ]}
        >
            <AIEraCareerBanner />
        </SubscriptionPlansProvider>
    );
};
